/**
 * Label type for ILabelModel
 */
export enum RcaDaneValidationLabelType {
  DNS = "DNS",
  DNSSEC = "DNSSEC",
  TLSA = "TLSA",
  DANE = "DANE",
}

/**
 * Label state for ILabelModel
 */
export enum RcaDaneValidationLabelState {
  Success = "Success",
  Failed = "Failed",
  Warning = "Warning",
  Skipped = "Skipped",
}
